import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { TaskLockingType, TaskRepetitionType, TaskVisibility } from "ui/Scripts/source/models/enums";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface ITaskTypeEditItem extends IEditItem {
    code: string;
    comment: string;
    taskRepetitionType: TaskRepetitionType;
    taskLockingType: TaskLockingType;
    dataSchema: string;
    printOrientationLandscape: boolean;
    visibility: TaskVisibility;
    activeState: number;
    modifyUser: IModifyUser;
}

export class TaskTypeEditItem extends EditItem implements ITaskTypeEditItem {
    code: string;
    comment: string;
    taskRepetitionType: TaskRepetitionType;
    taskLockingType: TaskLockingType;
    dataSchema: string;
    printOrientationLandscape: boolean;
    visibility: TaskVisibility;
    activeState: number;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: ITaskTypeEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.taskRepetitionType = obj && obj.taskRepetitionType || TaskRepetitionType.NotRepeated;
        this.taskLockingType = obj && obj.taskLockingType || TaskRepetitionType.NotRepeated;
        this.dataSchema = obj && obj.dataSchema || "";
        this.printOrientationLandscape = obj && obj.printOrientationLandscape || false;
        this.visibility = obj && obj.visibility || TaskVisibility.PrivateAndPublic;
        this.activeState = obj && obj.activeState || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}